export default __webpack_public_path__ + "static/media/icon-login.51d46a40.svg";